<template>
  <v-dialog
    v-model="visible"
    width="80%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
    persistent
    content-class="elevation-0"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        Neue Nachricht
        <v-spacer></v-spacer>
        <v-btn @click="makeTest()" v-if="$vars.beta">Testdatein eintragen</v-btn>
        <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-2">
        <v-row>
          <v-col cols="12" class="py-1 pt-3 px-1">
            <v-autocomplete
              outlined
              dense
              small-chips
              chips
              deletable-chips
              clearable
              multiple
              hide-details
              name="Gruppen"
              @input="checkIsSendDisabled"
              v-model="nachricht.gruppen"
              :items="gruppen"
              label="Gruppen"
            >
              <template v-slot:append>
                <v-chip small label>{{ kontakteAusGruppen ? kontakteAusGruppen.length : 0 }}</v-chip>
              </template>
              <template v-slot:append-outer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card flat class="transparent" dark width="200px">
                    Kontakte aus Gruppen werden automatisch als BCC versendet. Doppelte Kontakte werden ignoriert.
                  </v-card>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="py-1 px-1">
            <v-autocomplete
              outlined
              dense
              small-chips
              chips
              deletable-chips
              clearable
              multiple
              hide-details
              name="An"
              @input="checkIsSendDisabled"
              v-model="nachricht.an"
              :items="bbrbbr"
              label="An"
            >
              <template v-slot:append>
                <v-chip small label>{{ nachricht.an ? nachricht.an.length : 0 }}</v-chip>
              </template>
              <template v-slot:append-outer v-if="!showcc || !showbcc">
                <v-btn v-if="!showcc" small text class="mt-0 pt-0" @click="showcc = true">CC</v-btn>
                <v-btn v-if="!showbcc" small text class="mt-0 pt-0" @click="showbcc = true">BCC</v-btn>
                <v-btn v-if="!showcc" small text class="mt-0 pt-0" @click="showan_adresse = true">Mailadresse</v-btn>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="py-1 px-1" v-if="showan_adresse">
            <v-combobox
              outlined
              dense
              small-chips
              chips
              deletable-chips
              clearable
              multiple
              hide-details
              name="An Mailadressen"
              v-model="nachricht.an_adresse"
              @input="checkIsSendDisabled"
              label="An Mailadressen"
              @change="formatEmails"
              @blur="formatEmails"
            >
              <template v-slot:append>
                <v-chip small label>{{ nachricht.an_adresse ? nachricht.an_adresse.length : 0 }}</v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-col cols="12" class="py-1 px-1" v-if="showcc">
            <v-autocomplete
              outlined
              dense
              small-chips
              chips
              deletable-chips
              clearable
              multiple
              hide-details
              name="CC"
              v-model="nachricht.cc"
              @input="checkIsSendDisabled"
              :items="bbrbbr"
              label="CC"
            >
              <template v-slot:append>
                <v-chip small label>{{ nachricht.cc ? nachricht.cc.length : 0 }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="py-1 px-1" v-if="showbcc">
            <v-autocomplete
              outlined
              dense
              small-chips
              chips
              deletable-chips
              clearable
              multiple
              hide-details
              name="BCC"
              v-model="nachricht.bcc"
              @input="checkIsSendDisabled"
              :items="bbrbbr"
              label="Bcc"
            >
              <template v-slot:append>
                <v-chip small label>{{ nachricht.bc ? nachricht.bcc.length : 0 }}</v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" class="px-1">
            <v-text-field
              outlined
              dense
              hide-details
              label="Betreff*"
              @input="checkIsSendDisabled"
              v-model="nachricht.betreff"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="px-1">
            <v-select
              outlined
              dense
              hide-details
              :items="absender"
              label="Absender*"
              v-model="nachricht.absenderPosition"
              @change="checkIsSendDisabled"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card flat class="transparent" dark width="200px">
                    Wähle hier die Position aus, von welcher du die Mail senden willst. Sollte dein Amt nicht aufgeführt
                    sein sind keine Maildaten hinterlegt. Wende dich dann an den Admin.
                  </v-card>
                </v-tooltip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="3" class="px-1">
            <v-select
              clearable
              outlined
              dense
              hide-details
              label="Template"
              :items="templates"
              v-model="nachricht.template"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card flat class="transparent" dark width="200px">
                    Die Templates sind die Designvorlage in welche deine Mail eingebettet wird. Wenn du das Template
                    entfernst wird ein normaler Text versendet.
                  </v-card>
                </v-tooltip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" class="align-center">
            <v-card outlined class="d-flex align-center justify-space-between pa-2">
              <v-icon>attach_file</v-icon>
              <v-sheet color="transparent" max-width="70%" class="d-flex align-center flex-wrap align-content-center">
                <!-- Chips für uploadedFiles -->
                <v-chip label small v-for="(item, index) in uploadedFiles" :key="index" class="mr-2 mb-2">
                  <v-sheet class="text-truncate" max-width="150" color="transparent">{{ item.name }}</v-sheet>
                  <v-progress-circular
                    v-if="uploadStatus[index] < 100"
                    :value="uploadStatus[index]"
                    class="ml-2"
                    size="20"
                    rotate="-90"
                    color="primary"
                    width="3"
                  ></v-progress-circular>
                  <v-btn v-else icon><v-icon color="green">check</v-icon></v-btn>
                </v-chip>

                <!-- Chips für attachments -->
                <v-chip label small v-for="(item, index) in attachments" :key="index" class="mr-2 mb-2">
                  <v-sheet class="text-truncate" max-width="150" color="transparent">{{ item.name }}</v-sheet>
                  <v-btn icon @click="deleteFile(index)"><v-icon>delete</v-icon></v-btn>
                </v-chip>
              </v-sheet>
              <span>
                <v-btn color="primary" rounded dark :loading="loading" @click="handleFileImport"
                  >Anhang auswählen
                </v-btn>
                <input multiple ref="uploader" class="d-none" type="file" @change="onFileChanged" />
              </span>
            </v-card>
          </v-col>
          <v-col cols="12" class="px-1">
            <v-textarea
              label="Nachricht*"
              auto-grow
              rows="10"
              outlined
              dense
              hide-details
              v-model="nachricht.text"
              @input="checkIsSendDisabled"
            ></v-textarea>
          </v-col>
          <v-col cols="12" class="d-flex justify-end">
            <span>Antworten auf diese Mail werden an {{ replyToMail }} gesendet.</span>
          </v-col>
          <!-- <v-col cols="6" class="py-0 pr-1 d-flex justify-end">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn depressed :loading="$vars.loading" class="rounded-r-0 rounded-l-lg primary" @click="getAPI()" v-on="on"><v-icon>auto_awesome</v-icon></v-btn>
              <v-btn depressed :loading="$vars.loading" class="rounded-l-0 rounded-r-lg primary" dark icon @click="showAPISettings = true" v-on="on"><v-icon small>settings</v-icon></v-btn>
            </template>
            <span>Erstelle eine automatische Einladungsmail zur nächsten Veranstaltung.</span>
          </v-tooltip>
        </v-col> -->
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn rounded text @click="close()">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              rounded
              class="mr-2"
              v-on="on"
              text
              :class="!nachricht.template ? 'grey ' : 'primary--text '"
              :read-only="!nachricht.template"
              @click="showVorschau = true"
              >Vorschau</v-btn
            >
          </template>
          <v-card flat class="transparent" dark width="200px" v-if="!nachricht.template">
            <span v-if="!nachricht.template">Es muss ein Template ausgewählt werden.</span>
          </v-card>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn rounded class="primary" :disabled="isSendDisabled" @click="sendMail()">
              <v-icon class="mr-2">send</v-icon>Senden
            </v-btn>
          </template>
          <v-card
            flat
            class="transparent"
            dark
            width="200px"
            v-if="
              !nachricht.text ||
              !nachricht.betreff ||
              !nachricht.absenderPosition ||
              (!nachricht.an.length > 0 &&
                !nachricht.cc.length > 0 &&
                !nachricht.bcc.length > 0 &&
                !nachricht.gruppen.length > 0)
            "
          >
            <span v-if="!nachricht.text">Die Nachricht darf nicht leer sein.</span>
            <span v-if="!nachricht.betreff">Der Betreff darf nicht leer sein.</span>
            <span v-if="!nachricht.absenderPosition">Es muss ein Absender ausgewählt werden.</span>
            <span
              v-if="
                !nachricht.an.length > 0 &&
                !nachricht.an_adresse.length > 0 &&
                !nachricht.cc.length > 0 &&
                !nachricht.bcc.length > 0 &&
                !nachricht.gruppen.length > 0
              "
              >Es muss mindestens ein Empfänger in "Gruppen", "An", "CC" oder "BCC" ausgewählt sein.</span
            >
          </v-card>
        </v-tooltip>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showAPISettings" :fullscreen="$vuetify.breakpoint.smAndDown" width="50%" persistent scrollable>
      <v-card>
        <v-card-title>
          API Settings
          <v-spacer></v-spacer>
          <v-btn icon @click="showAPISettings = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-textarea
            dense
            outlined
            hide-details
            rows="6"
            auto-grow
            label="Eingabe zur API"
            v-model="apiSettings"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAPISettings = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showVorschau" :fullscreen="$vuetify.breakpoint.smAndDown" width="80%" persistent scrollable>
      <v-card>
        <v-card-title>
          Vorschau
          <v-spacer></v-spacer>
          <v-btn icon @click="showVorschau = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-card outlined>
            <v-card-title class="pa-2 pl-4">
              {{ nachricht.betreff ? nachricht.betreff : "" }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="subtitle-2 pa-2">
              Von:
              <span v-if="nachricht.absenderPosition">{{ nachricht.absenderPosition }}</span>
              <div v-if="nachricht.an" class="mt-1">
                An:
                <v-chip label class="mr-1" small v-for="(item2, index2) in nachricht.gruppen" :key="index2 * 2">
                  <v-avatar left><v-icon>group</v-icon></v-avatar>
                  {{ item2 }}
                </v-chip>
                <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an" :key="index * 2 + 1">
                  <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
                  {{ $filters.user(item, bundesbruder) }}
                </v-chip>
              </div>
              <div v-if="nachricht.an_adresse" class="mt-1">
                An Mailadressen:
                <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_adresse" :key="index * 2 + 1">
                  {{ item }}
                </v-chip>
              </div>
              <div v-if="nachricht.an_cc && nachricht.an_cc.length > 0" class="mt-1">
                CC:
                <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_cc" :key="index">
                  <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
                  {{ $filters.user(item, bundesbruder) }}
                </v-chip>
              </div>
              <div v-if="nachricht.an_bcc && nachricht.an_bcc.length > 0" class="mt-1">
                BCC:
                <v-chip pill class="mr-1" small v-for="(item, index) in nachricht.an_bcc" :key="index">
                  <v-avatar left><v-icon>account_circle</v-icon></v-avatar>
                  {{ $filters.user(item, bundesbruder) }}
                </v-chip>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="ma-0 pa-0">
              <v-sheet
                ref="cardText"
                class="pa-4"
                style="overflow-y: auto"
                max-height="500"
                v-html="nachrichtVorschau"
              ></v-sheet>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showVorschau = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  export default {
    props: ["bbr", "visible", "copynachricht"],
    data() {
      return {
        apiSettings:
          "Schreibe eine ausführliche Einladungsmail der nächsten Veranstaltung der Studentenverbindung Ripuaria, unserer Abkneipe, am 27. Januar 2022. Duze den Empfänger und schreibe ihn mit Lieber Bundesbruder an.",
        attachments: [],
        showAPISettings: false,
        showcc: false,
        showbcc: false,
        showan_adresse: false,
        showVorschau: false,
        uploadStatus: [],
        anhange: [],
        imgFile: null,
        loading: false,
        isSelecting: false,
        uploadedFiles: [],
        isSendDisabled: true,
        nachricht: {
          an: [],
          cc: [],
          bcc: [],
          an_adresse: [],
          gruppen: [],
          message: {},
          absender: {},
          anhang: [],
        },
      };
    },
    watch: {
      copynachricht: {
        handler: function (newValue) {
          this.nachricht.an = newValue.message.an ? newValue.message.an : "";
          this.nachricht.cc = newValue.message.cc ? newValue.message.cc : "";
          this.nachricht.bcc = newValue.message.bcc ? newValue.message.bcc : "";
          this.nachricht.gruppen = newValue.message.gruppen ? newValue.message.gruppen : "";
          this.attachments = newValue.message.attachments ? newValue.message.attachments : "";
          this.nachricht.absender = newValue.message.absender ? newValue.message.absender : "";
          this.nachricht.betreff = newValue.message.subject ? newValue.message.subject : "";
          this.nachricht.template = newValue.template ? newValue.template : "";
          this.nachricht.text = newValue.message.text ? newValue.message.text.replace(/<br>/g, "\n") : "";
        },
        deep: true,
      },
    },
    computed: {
      currentBbr() {
        return this.$getCurrentBbr();
      },
      absenderData() {
        return this.$store.getters["bbrbbr/bbr"](this.currentBbr);
      },
      bundesbruder() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      bbrbbr() {
        let bbrbbr = [];
        this.$store.state.bbrbbr.bbrbbr.forEach((bbr) => {
          bbrbbr.push({
            id: bbr.id,
            value: bbr.id,
            name: bbr.nachname + ", " + bbr.vorname,
            text: bbr.nachname + ", " + bbr.vorname,
          });
        });
        return bbrbbr;
      },
      replyTo() {
        if (this.nachricht.absenderPosition) {
          return this.$store.getters["einstellungen/einstellung"]("rollen").seiten.find(
            (item) => item.titel === this.nachricht.absenderPosition
          ).sendMail.replyTo;
        }
      },
      replyToMail() {
        if (this.nachricht.absenderPosition) {
          if (this.replyTo === "absender") {
            return this.absenderData.email;
          }
          if (this.replyTo === "from") {
            return this.$store.getters["einstellungen/einstellung"]("rollen").seiten.find(
              (item) => item.titel === this.nachricht.absenderPosition
            ).sendMail.adresse;
          }
        }
      },
      absender() {
        console.log("absender computed");
        let absender = [];
        let rollen = this.$store.getters["einstellungen/einstellung"]("rollen");
        rollen.seiten.forEach((rolle) => {
          if (rolle.berechtigt.indexOf(this.currentBbr) !== -1) {
            console.log(rolle);
            if (rolle.sendMail.adresse) {
              absender.push(rolle.titel);
            }
          }
        });
        if (absender.length === 1) {
          this.nachricht.absenderPosition = absender[0];
        }
        return absender;
      },
      nachrichtVorschau() {
        if (this.showVorschau) {
          let template = this.nachricht.template;
          let absenderData = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
          let absender = {
            vorname: absenderData.vorname || "",
            nachname: absenderData.nachname || "",
            adresse: absenderData.adresse || "",
            plz: absenderData.plz || "",
            ort: absenderData.ort || "",
            email: this.replyToMail || "",
            handy: absenderData.handy || "",
            telefon: absenderData.telefon || "",
          };
          absender.position = this.nachricht.absenderPosition;

          template = template.replace(/<<nachricht.titel>>/g, this.nachricht.betreff);
          template = template.replace(/<<nachricht.inhalt>>/g, this.nachricht.text.replace(/(?:\r\n|\r|\n)/g, "<br>"));
          template = template.replace(/<<absender.vorname>>/g, absender.vorname);
          template = template.replace(/<<absender.nachname>>/g, absender.nachname);
          template = template.replace(/<<absender.name>>/g, absender.vorname + " " + absender.nachname);
          template = template.replace(/<<absender.adresse>>/g, absender.adresse);
          template = template.replace(/<<absender.plz>>/g, absender.plz);
          template = template.replace(/<<absender.ort>>/g, absender.ort);
          template = template.replace(/<<absender.email>>/g, absender.email);
          template = template.replace(/<<absender.handy>>/g, absender.handy);
          template = template.replace(/<<absender.telefon>>/g, absender.telefon);
          template = template.replace(/<<absender.position>>/g, absender.position);
          template = template.replace(
            /<<Veranstaltungen>>/g,
            "Beim Versenden werden hier die kommenden drei Veranstaltungen eingefügt."
          );

          return template;
        }
      },
      templates() {
        let templates = [];
        const items = this.$store.getters["einstellungen/einstellung"]("templates");
        if (items.templates) {
          items.templates.forEach((item) => {
            if (item.kategorie === "Mail") {
              templates.push({
                text: item.name,
                value: item.html,
              });
            }
          });
        }
        return templates;
      },
      gruppen() {
        let gruppen = [];
        let id = 0;
        let items = this.$store.getters["einstellungen/einstellung"]("gruppen");
        if (items.gruppen) {
          items.gruppen.forEach((item) => {
            item.gruppen.forEach((gruppe) => {
              gruppen.push({
                id,
                bedingungen: gruppe.bedingungen,
                value: gruppe.text,
                name: gruppe.text,
                text: gruppe.text,
              });
              id++;
            });
          });
        }
        return gruppen;
      },
      kontakteAusGruppen() {
        let bbrbbr = [];
        if (this.nachricht.gruppen) {
          this.nachricht.gruppen.forEach((gruppenname) => {
            let bedingungen = this.gruppen.find((gruppe) => gruppenname === gruppe.text).bedingungen;
            this.$store.state.bbrbbr.bbrbbr.forEach((item) => {
              bedingungen.forEach((val) => {
                console.log(val);
                if (typeof val.wert === "string") {
                  val.wert = val.wert.split(",");
                }
                val.wert.forEach((valueWert) => {
                  if (Array.isArray(item[val.feld])) {
                    if (item[val.feld].indexOf(valueWert) !== -1) {
                      if (bbrbbr.indexOf(item) === -1) {
                        bbrbbr.push(item);
                      }
                    }
                  } else {
                    if (valueWert === item[val.feld]) {
                      if (bbrbbr.indexOf(item) === -1) {
                        bbrbbr.push(item);
                      }
                    }
                  }
                });
              });
            });
          });
        }
        return bbrbbr;
      },
    },
    methods: {
      makeTest() {
        this.nachricht.betreff = "Testmail + " + new Date().getTime();
        this.nachricht.text = "Testmail + " + new Date().getTime();
        this.nachricht.an_adresse = [];

        this.nachricht.an_adresse.push("wordpress+1@benediktbreuer.de");
      },
      handleFileImport() {
        this.isSelecting = true;
        window.addEventListener(
          "focus",
          () => {
            this.isSelecting = false;
          },
          { once: true }
        );
        this.$refs.uploader.click();
        this.imgFile = null;
      },
      async onFileChanged(e) {
        await this.uploadData(Array.from(e.target.files));
      },
      formatEmails() {
        if (!this.nachricht.an_adresse) return;

        // Kombiniert alle Eingaben
        let rawInput = this.nachricht.an_adresse.join(",");

        // Entfernt unerwünschte Zeichen (erlaubt sind Buchstaben, Zahlen und typische E-Mail-Zeichen)
        rawInput = rawInput.replace(/[^a-zA-Z0-9@._%+-;, ]/g, "");

        // Trennen von E-Mails anhand von Komma, Semikolon oder Leerzeichen
        let emails = rawInput
          .split(/[\s,;]+/) // Teilt bei Komma, Semikolon oder Leerzeichen
          .map((email) => email.trim()) // Entfernt Leerzeichen
          .filter((email) => email.length > 0) // Entfernt leere Einträge
          .filter((email, index, self) => self.indexOf(email) === index); // Entfernt Duplikate

        // Gültige E-Mail-Adressen filtern (entspricht dem RFC 5322-Standard)
        emails = emails.filter((email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email));

        // Aktualisiert das Modell
        this.nachricht.an_adresse = emails;
      },
      checkIsSendDisabled() {
        this.isSendDisabled =
          !this.nachricht.text ||
          !this.nachricht.betreff ||
          !this.nachricht.absenderPosition ||
          ((!this.nachricht.an || this.nachricht.an.length === 0) &&
            (!this.nachricht.an_adresse || this.nachricht.an_adresse.length === 0) &&
            (!this.nachricht.cc || this.nachricht.cc.length === 0) &&
            (!this.nachricht.bcc || this.nachricht.bcc.length === 0) &&
            (!this.nachricht.gruppen || this.nachricht.gruppen.length === 0));
      },
      uploadData(files) {
        console.log("uploadData");
        console.log(files);
        let attachments = [];
        this.loading = true;
        this.uploadedFiles = files;
        console.log(this.loading);
        this.uploadStatus = Array(files.length).fill(0); // Korrigiere das Array basierend auf der Anzahl der Dateien

        files.forEach((file, index) => {
          const fileName = file.name;
          let name = new Date().getTime() + file.name;
          const storageRef = this.$firebase
            .storage()
            .ref("mailAnhange/" + name)
            .put(file);

          storageRef.on(
            `state_changed`,
            (snapshot) => {
              const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

              // Aktualisiere den Status des aktuellen Files reaktiv
              this.$set(this.uploadStatus, index, progress);

              this.uploadValue = progress;
              console.log(this.uploadStatus);
            },
            (error) => {
              this.$set(this.uploadStatus, index, { error: error.message });
            },
            () => {
              storageRef.snapshot.ref.getDownloadURL().then((url) => {
                attachments.push({
                  name: fileName,
                  filename: fileName,
                  path: url,
                });

                if (this.uploadStatus.every((status) => status === 100)) {
                  this.uploadedFiles = [];
                  if (!Array.isArray(this.attachments)) {
                    this.attachments = [];
                  }
                  while (attachments.length > 0) {
                    const attachment = attachments.shift(); // Entferne das erste Element aus `attachments`
                    this.attachments.push(attachment); // Füge es in `this.attachments` hinzu
                  }
                  this.loading = false;
                  console.log(this.loading);
                  this.uploadValue = 0;
                }
              });
            }
          );
        });
      },
      deleteFile(index) {
        // Entferne das File aus attachments
        this.attachments.splice(index, 1);
      },
      sendMail() {
        console.log("sendMail");
        try {
          let betreff = this.nachricht.betreff;
          let text = this.nachricht.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
          let from = this.$store.getters["bbrbbr/bbr"](this.currentBbr).email;
          let to = [];
          let cc = [];
          let bcc = [];
          let anGruppen = [];
          let absenderData = this.$store.getters["bbrbbr/bbr"](this.currentBbr);
          let absender = {
            vorname: absenderData.vorname || "",
            nachname: absenderData.nachname || "",
            adresse: absenderData.adresse || "",
            plz: absenderData.plz || "",
            ort: absenderData.ort || "",
            email: this.replyToMail || "",
            handy: absenderData.handy || "",
            telefon: absenderData.telefon || "",
          };
          absender.position = this.nachricht.absenderPosition;
          if (this.nachricht.gruppen) {
            this.kontakteAusGruppen.forEach((item) => {
              if (item.email) {
                bcc.push(item.email);
                // bcc.push("wordpress+" + item.id + "@benediktbreuer.de");
                anGruppen.push(item.id);
              }
            });
          }
          if (this.nachricht.an) {
            this.nachricht.an.forEach((item) => {
              to.push(this.$store.getters["bbrbbr/bbr"](item).email);
            });
          }
          if (this.nachricht.cc) {
            this.nachricht.cc.forEach((item) => {
              cc.push(this.$store.getters["bbrbbr/bbr"](item).email);
            });
          } else {
            this.nachricht.cc = [];
          }
          // Nur zu Testzwecken
          // for (let i = 0; i < 500; i++) {
          //   bcc.push("wordpress+" + i + "@benediktbreuer.de");
          // }
          if (this.nachricht.bcc) {
            this.nachricht.bcc.forEach((item) => {
              bcc.push(this.$store.getters["bbrbbr/bbr"](item).email);
            });
          } else {
            this.nachricht.bcc = [];
          }
          if (this.nachricht.an_adresse) {
            this.nachricht.an_adresse.forEach((item) => {
              to.push(item);
            });
          }
          if (!this.nachricht.template) {
            this.nachricht.template = null;
          }
          console.log(this.nachricht);
          this.$store.dispatch("mails/createEinMails", {
            art: "mail",
            from,
            to,
            cc,
            bcc,
            absender,
            status: "Warte auf Versand..",
            gruppen: this.nachricht.gruppen ? this.nachricht.gruppen : [],
            von: this.currentBbr,
            an: this.nachricht.an,
            an_gruppen: anGruppen,
            an_adresse: this.nachricht.an_adresse,
            an_cc: this.nachricht.cc,
            an_bcc: this.nachricht.bcc,
            template: this.nachricht.template,
            message: {
              subject: betreff,
              text: text,
            },
            attachments: this.attachments,
            datum: new Date(),
          });
          this.close();
          this.nachricht = {
            an: [],
            cc: [],
            bcc: [],
            an_adresse: [],
            gruppen: [],
            message: {},
            absender: {},
          };
        } catch (error) {
          console.log(error);
          this.$vars.error.nachricht = "Beim Versenden der Mail ist ein Fehler aufgetreten.";
          this.$vars.error.error = error;
          this.$vars.error.show = true;
        }
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// dialogMailNeu.vue?7e9c3736